import React from 'react';
import { Facebook, Instagram } from 'lucide-react';
import { languages } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-[#f8f9fa] py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center space-y-6">
          {/* Logo */}
          <img 
            src="https://www.sweetlife.com.br/images/logo.png" 
            alt="Sweet Life" 
            className="h-16 w-auto"
          />
          
          {/* Social Links */}
          <div className="flex space-x-6">
            <a 
              href="https://www.facebook.com/sweetlifebalasdiet" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#3b7ba8] hover:text-[#2d5f85] transition-colors duration-200"
            >
              <Facebook size={32} />
            </a>
            <a 
              href="https://www.instagram.com/sweetlifebalasdiet/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#3b7ba8] hover:text-[#2d5f85] transition-colors duration-200"
            >
              <Instagram size={32} />
            </a>
            <a 
              href="https://www.tiktok.com/@sweet.life.balas" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#3b7ba8] hover:text-[#2d5f85] transition-colors duration-200"
            >
              <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
              </svg>
            </a>
          </div>

          {/* Contact Info */}
          <p className="text-gray-700 text-sm md:text-base">
            Sweet Life Balas Diet | (22) 2580-3540
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
